import { Component, Input, ViewChild } from '@angular/core';
import { ScrollContainerDirective } from '@shared/directives/scroll-container.directive';

@Component({
  selector: 'mfp-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  @Input() backgroundImage = '';
  @Input() showHeader = true;
  @Input() headerBorder = true;
  @Input() contentCentered = false;
  @Input() contentPadding = false;
  @Input() showMenu: 'none' | 'header' | 'both' = 'none';
  @Input() showFooter = true;

  @ViewChild(ScrollContainerDirective) scrollContainerDirective!: ScrollContainerDirective;

  constructor() { }
}
